import React, { forwardRef } from 'react';
import ConfigModal from '../ConfigModal';
import { Switch } from 'antd';
import PropTypes from 'prop-types';
import TierSelect from '../TierSelect';
import RenewalPeriodSelect from '../RenewalPeriodSelect';

const FormSwitch = forwardRef(({ value, onChange, ...props }, ref) => {
	return <Switch ref={ref} checked={value} disabled={true} onChange={onChange} {...props} />;
});

const SocratesAddTeamModal = ({ open, organizationId, tiers, onCancel, onSubmit }) => {
	return (
		<ConfigModal
			title={`Lägg till Socrates team`}
			open={open}
			onSubmit={onSubmit}
			onCancel={onCancel}
			values={{
				tierID: tiers && tiers.length > 0 ? tiers[0].id : undefined,
				canShareQuota: true,
				renewalPeriod: 1, // Default to QUARTERLY
				isActive: true,
			}}
			createNew={true}
			disableMask
			formItems={[
				{
					id: 'tierID',
					label: 'Frågor',
					decorator: {
						rules: [{ required: true, message: 'Frågor är obligatoriska' }],
					},
					component: <TierSelect tiers={tiers} />,
				},
				{
					id: 'renewalPeriod',
					label: 'Förnyelseperiod',
					decorator: {
						rules: [{ required: true, message: 'Förnyelseperiod är obligatorisk' }],
					},
					component: <RenewalPeriodSelect />,
				},
				{
					id: 'canShareQuota',
					label: 'Kan dela kvot',
					decorator: {},
					component: <FormSwitch />,
				},
				{
					id: 'isActive',
					label: 'Aktiv',
					decorator: {},
					component: <FormSwitch />,
				},
			]}
		/>
	);
};

SocratesAddTeamModal.propTypes = {
	organizationId: PropTypes.string.isRequired,
	open: PropTypes.bool,
	onSubmit: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired,
	tiers: PropTypes.array,
};

SocratesAddTeamModal.defaultProps = {
	open: false,
	tiers: [],
};

export default SocratesAddTeamModal;



// WEBPACK FOOTER //
// ./src/components/socrates/socratesAddTeamModal.jsx